import React from 'react'
import styled from 'styled-components'

import Container from '../../../components/Container'
import { HEADER_HEIGHT_DESKTOP } from '../../../theme'
import { MEDIA_QUERY_DESKTOP } from '../../../utils/media-query'
import { ButtonPrimary, Paragraph, TitleFour, TitleOne } from '../../ObjectsNew/styled'

const Component = styled.div`
  margin-top: -${HEADER_HEIGHT_DESKTOP + 2}px;
  height: 100vh;
  width: 100%;
  background: url('/images/ethereal-gui.jpeg');
  background-size: cover;
  background-position: top center;
  background-repeat: no-repeat;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, .1);
  }
`

const Content = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  z-index: 5;
  bottom: 2rem;
  // text-align: center;

  ${TitleOne} {
    line-height: 1;
    font-size: 45px;

    ${MEDIA_QUERY_DESKTOP} {
      font-size: 58px;
    }
  }

  ${Paragraph} {
    margin-top: .5rem;
  }

  ${MEDIA_QUERY_DESKTOP} {
    bottom: 8rem;
    text-align: left;
  }
`

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${TitleFour} {
    margin-top: 1rem;
    max-width: 765px;
    font-size: 18px;

    ${MEDIA_QUERY_DESKTOP} {
      font-size: 37px;
      line-height: 1.3;
    }
  }

  ${MEDIA_QUERY_DESKTOP} {
    text-align: left;
  }
`

const Footer = styled.div`
  ${MEDIA_QUERY_DESKTOP} {
    margin-top: 1rem;
  }
`

const GuiHeader = () => {
  const handleBtnOpenClick = () => {
    const elFirstHighlight = document.getElementById('collection')

    if (!elFirstHighlight) {
      return
    }

    elFirstHighlight.scrollIntoView({
      behavior: 'smooth'
    })
  }

  return (
    <Component>
      <Content>
        <Container>
          <TitleContainer>
            <TitleOne>
              Gui x Friends
              <br />
              // OUT NOW
            </TitleOne>
            <TitleFour>
              A drop by Gui Boratto, Robert Babicz, Coppola and L_CIO.
            </TitleFour>
          </TitleContainer>
          <Footer>
            <ButtonPrimary onClick={handleBtnOpenClick}>
              Show collection
            </ButtonPrimary>
          </Footer>
        </Container>
      </Content>
    </Component>
  )
}

export default GuiHeader
